import * as React from 'react';
import { useForm, ErrorMessage } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
// import { CSVReader } from 'react-papaparse';

// export default () => {
const Step1 = props => {
  const { state, action } = useStateMachine(updateAction);
  const { handleSubmit, errors, register } = useForm({
    defaultValues: state.yourDetails
  });
  const { push } = useHistory();
  const onSubmit = data => {
    action(data);
    push("/step2");
  };

  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* <span style={{color: "#44BEA8", 'font-weight': "600"}}>
        save money and improve profits based on targeting groups with unique marketing campaigns based on each specific segment
        <br></br>
        <br></br>
      </span> */}
      {/* <span className="subtitle">
            <span>
            <span className="" style={{'font-weight': "bold"}}>Cost savings:</span> Rather than using resources to send out marketing tactics to every customer, can decide based on segments which customers will be most likely to respond with a purchase.<br></br><br></br>
            <span className="" style={{'font-weight': "bold"}}>Profit improvement:</span> By using the segments to determine who is more likely to make a purchase, you can target those customers and will have a higher return on your marketing investment.<br></br><br></br>
            <span className="" style={{'font-weight': "bold"}}>Examples:</span> Customers with high frequency and monetary value but low recency, you may want to remind them of your existence and perhaps give them a discount code to encourage their business. Customers with high frequency, recency and monetary value, you may want to show them your appreciation to keep them as a good customer.
            </span>
            <br></br>
            <br></br>
      </span> */}
      <h3>Fill out the form below to try the demo!</h3>
      <label>
        First Name
        <input
          name="firstName"
          ref={register({ required: "This is required." })}
        />
        <ErrorMessage errors={errors} name="firstName" as="p" />
      </label>
      <label>
        Last Name
        <input
          name="lastName"
          ref={register({ required: "This is required." })}
        />
        <ErrorMessage errors={errors} name="lastName" as="p" />
      </label>
      <label>
        Company
        <input
          name="company"
          ref={register({ required: "This is required." })}
        />
        <ErrorMessage errors={errors} name="company" as="p" />
      </label>
      <label>
        Business Email address
        <input
          name="email"
          ref={register({ 
            required: "This is required.",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "invalid email address"
            }
          })}
        />
        <ErrorMessage errors={errors} name="email" as="p" />
      </label>

      <input type="submit" value="Next"/>
    </form>
    </>
  );
}
export default Step1;